import React, { useState } from "react";
import "./style.css";
import { formatCNPJ } from "../../utils/utilityFunctions";

const normalizeSearchValue = (value) =>
  (value || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

const ProfileSelectCard = ({ profile, isSelected, onSelect }) => {
  return (
    <div
      className={`profile-select-card ${isSelected ? "selected" : ""}`}
      onClick={() => onSelect(profile.id)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onSelect(profile.id);
        }
      }}
    >
      <div className="profile-card-header">
        <h3 className="profile-company-name">
          {profile.company_name.toUpperCase()}
        </h3>
        {isSelected && (
          <span className="selected-check" aria-label="Selecionado">
            ✓
          </span>
        )}
      </div>
      <div className="profile-card-body">
        <div className="profile-info-item">{profile.name}</div>
        <div className="profile-info-item">{formatCNPJ(profile.cnpj)}</div>
      </div>
    </div>
  );
};

const ProfileSelectGrid = ({
  profiles,
  selectedId,
  onSelect,
  viewModeToggle,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProfiles = profiles?.filter((profile) => {
    if (!searchTerm) return true;
    // CNPJ é normalizado (remove pontuação) porque é exibido formatado; nome não precisa disso.
    const normalizedTerm = normalizeSearchValue(searchTerm);
    return (
      (profile.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      normalizeSearchValue(profile.cnpj).includes(normalizedTerm)
    );
  });

  const totalCount = profiles?.length ?? 0;
  const filteredCount = filteredProfiles?.length ?? 0;

  return (
    <div className="profile-select-container">
      <h1 className="profile-select-title">
        Escolha a unidade consumidora para visualizar suas informações
      </h1>

      <div className="profile-search-row">
        {viewModeToggle}

        <div className="profile-search-group">
          <input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="profile-search-input"
            placeholder=" "
          />
          <span className="profile-search-bar" />
          <label className="profile-search-label">
            Buscar unidade por nome ou CNPJ
          </label>
        </div>

        <span className="profile-search-count">
          {searchTerm
            ? `${filteredCount} filtrados de ${totalCount}`
            : `${totalCount} unidades`}
        </span>
      </div>

      <div className="profile-cards-grid">
        {filteredProfiles?.map((profile) => (
          <ProfileSelectCard
            key={profile.id}
            profile={profile}
            isSelected={profile.id === selectedId}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
};

export default ProfileSelectGrid;
